module.exports = __webpack_public_path__ + "img/benefit-icon_ticket.d457ce96.svg";